export { default } from './BlockAwardCardContent'